import styled from 'styled-components';
import { color, device } from '@stockbit/ui';
import { assetPrefix } from 'constants/app';

export const ContactContainer = styled.div`
  display: block;

  @media ${device.laptop} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 25px;
    grid-row-gap: 0px;
  }
`;

export const ContactBox = styled.div`
  border: 1px solid ${color.gainsboro};
  border-radius: 10px;
  margin-bottom: 25px;

  &.map {
    height: 320px;

    @media ${device.tablet} {
      height: 608px;
    }

    @media ${device.laptop} {
      height: auto;
    }
  }
`;

interface ContactItemProps {
  icon: string
}

export const ContactItem = styled.div < ContactItemProps > `
    background: url(${assetPrefix}/${(props) => props.icon}) no-repeat top left;
    padding: 0 20px 20px 75px;
    background-position: 20px 0;
    background-size: 32px 32px;
    word-break: break-word;

    @media ${device.tablet} {
      padding: 0 30px 30px 98px;
      background-position: 30px 0;
      background-size: 48px 48px;
      word-break: normal;
    }

    &:first-child {
      padding-top: 20px;
      background-position: 20px 20px;
      @media ${device.tablet} {
        padding-top: 30px;
        background-position: 30px 30px;
      }
    }

    p {
      font-size: 19px;
      margin-top: 0;
      margin-bottom: 0;
    }

    h5 {
      font-size: 19px;
    }
`;
